module.exports = __webpack_public_path__ + "static/tartare200-d56c1afdf539d15cbbbff0a36a16a71a.png";